import { render, staticRenderFns } from "./NotificationSetting.vue?vue&type=template&id=6da940ae"
import script from "./NotificationSetting.vue?vue&type=script&lang=js"
export * from "./NotificationSetting.vue?vue&type=script&lang=js"
import style0 from "./NotificationSetting.vue?vue&type=style&index=0&id=6da940ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports